// The canonical analytics key for the AI assistant feature.
// Kept as 'agent' to preserve continuity with historical analytics data.
export const kAnalyticsFeatureAgent = 'agent'

// Fallback matterId sent to Amplitude when no matter is in scope at the call site.
export const kNoMatterId = 'none'
